(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("JSONFormsWebcomponent", [], factory);
	else if(typeof exports === 'object')
		exports["JSONFormsWebcomponent"] = factory();
	else
		root["JSONFormsWebcomponent"] = factory();
})(window, function() {
return 